require("core-js/modules/es6.object.assign");

require("core-js/modules/es6.regexp.match");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.object.keys");

require("core-js/modules/es6.array.for-each");

var Parser = require('./parser');

module.exports = function (queries, options) {
  var result = {};
  Object.keys(queries).forEach(function (query) {
    if (Parser.parse(query).match(options)) {
      Object.assign(result, queries[query]);
    }
  });
  return result;
};